// components/features/calls/CallRow.tsx
import { Call } from '../../../../types/features/support/Call';
import TableRow from '../../../ui/TableRow';

interface CallRowProps {
  call: Call;
  onAction: (call: Call) => void;
  onSelect?: (call: Call, isSelected: boolean) => void;
  isSelected?: boolean;
  selectable?: boolean;
}

export default function CallRow({
  call,
  onAction,
  onSelect,
  isSelected = false,
  selectable = false
}: CallRowProps) {
  const formatDuration = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const formatDate = (date: string) => {
    return new Date(date).toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <TableRow
      item={call}
      onAction={onAction}
      onSelect={onSelect}
      isSelected={isSelected}
      selectable={selectable}
      actionable={true}
    >
      <td className="py-3 px-4">
        <div>
          <span className="font-medium text-gray-800 block">
            {call.client?.firstname && call.client?.lastname
              ? `${call.client.firstname} ${call.client.lastname}`
              : call.client?.phone || call.client_phone || 'Numéro inconnu'}
          </span>
          <span className="text-xs text-gray-500">
            {call.direction === 'entrant' ? 'Appel entrant' : 'Appel sortant'}
          </span>
        </div>
      </td>

      <td className="hidden sm:table-cell py-3 px-4">
        <span className="text-gray-600 text-sm">
          {formatDuration(call.duration)}
        </span>
      </td>

      <td className="hidden md:table-cell py-3 px-4">
        <div className="flex flex-wrap gap-1">
          {call.tags.map((tag, idx) => (
            <span key={idx} className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded">
              {tag}
            </span>
          ))}
        </div>
      </td>

      <td className="hidden lg:table-cell py-3 px-4">
        <span className="text-gray-500 text-xs">
          {formatDate(call.created_at)}
        </span>
      </td>
    </TableRow>
  );
}